import React from 'react';
import PropTypes from 'prop-types';
import { InfoPopupDispatcher } from '../../../_constants/info_popup';

function InfoPopupHeader(props) {
  return (
    <div
      className="info-popup-header"
      style={props.dispatcher === InfoPopupDispatcher.BUY_4_PAY_3 ? { fontWeight: '700' } : {}}
    >
      {!props.showCloseButton && <span className="info-popup-header__back" onClick={props.onBackClick} />}
      {props.headerContent}
    </div>
  );
}

InfoPopupHeader.propTypes = {
  headerContent: PropTypes.string.isRequired,
  onBackClick: PropTypes.func.isRequired,
};

export { InfoPopupHeader };
